"use client";

import { Box } from "@mui/material";
import { useSearchParams } from "next/navigation";
import { ReactNode } from "react";

const DEFAULT_RATIO = "16 / 9";

function normalizeRatio(ratio?: string | null) {
    if (!ratio) return DEFAULT_RATIO;
    const clean = ratio.toString().trim().replace(/\s*\/\s*/g, " / ");
    return /^\d+(\.\d+)?\s*\/\s*\d+(\.\d+)?$/.test(clean) ? clean : DEFAULT_RATIO;
}

export default function VideoEmbedRatioWrapper({ children }: { children: ReactNode }) {
    const searchParams = useSearchParams();
    const ratio = normalizeRatio(searchParams.get("ratio"));

    return (
        <Box sx={{ width: "100%", height: "100%", backgroundColor: "black", aspectRatio: ratio, overflow: "hidden" }}>
            {children}
        </Box>
    );
}
